<template>
  <div class="ds-error" role="alert">
    <p class="ds-error__title">{{ title ?? t('common.loadFailed') }}</p>
    <DsButton variant="secondary" @click="$emit('retry')">{{ t('common.retry') }}</DsButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import DsButton from './DsButton.vue';

/** Load failure with a retry (03 §6.1). */
defineProps<{ title?: string }>();
defineEmits<{ retry: [] }>();
const { t } = useI18n();
</script>

<style scoped lang="scss">
.ds-error { display: flex; flex-direction: column; align-items: center; gap: 14px; padding: 32px 16px; text-align: center; }
.ds-error__title { margin: 0; color: var(--text-2); font-size: 14px; }
</style>
